/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-11-01
 * @brief EHP DashBoard - 운영 현황 컴포넌트
 *
 ********************************************************************/
import React, { useState, useEffect } from "react";
import { useAsync } from "react-async";
import { useNavigate } from 'react-router-dom';
// recoil
import { useRecoilValue, useRecoilState, } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
import { loadingBoxState, urlState, czoneInfoState } from "../../../recoil/menuState";
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
/**
* @brief EHP DashBoard - 운영 현황 컴포넌트, 반응형 동작
* @param -
* @returns react components
*/
//component
function OperationStatus(props) {
    //trans, ref, navigate
    const navigate = useNavigate();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [urlInfo, setRecoilUrlInfo] = useRecoilState(urlState);
    const [isLoadingBox, setRecoilIsLoadinBox] = useRecoilState(loadingBoxState);
    const [czoneInfo, setRecoilCZoneInfo] = useRecoilState(czoneInfoState);
    //props
    const selTree = props.selTree;
    const [opStatus, setOpStatus] = useState({
        "subZoneCount": 0,
        "roomCount": 0,
        "userCount": 0,
        "itemCount": 0,
        "spg": {
            "acbCount": 0,
            "vcbCount": 0,
            "switchBoardCount": 0,
            "moldTrCount": 0,
            "oilTrCount": 0,
            "gisCount": 0
        }
    });
    const { data: retData, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/product/maindashboard/operate/count`,
        appQuery: { "zoneId": selTree.zone.zoneId },
        userToken: userInfo.loginInfo.token,
        watch: selTree,
    });
    useEffect(() => {
        setRecoilIsLoadinBox(true);
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, retData);
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (retData) {
            setRecoilIsLoadinBox(false);
            //clog("IN INFOCARS : OPERATION STATUS : RES : " + JSON.stringify(retData.body));
            if (retData.codeNum == CONST.API_200) {
                setOpStatus(retData.body);
                //clog("PIN LC INFO : " + czoneStr);
            }
        }
    }, [retData]);
    function onClickGoLink(url) {
        setRecoilCZoneInfo(selTree);
        setRecoilUrlInfo(url);
        navigate(url);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "box__header" },
            React.createElement("p", { className: "box__title" }, "\uC6B4\uC601 \uD604\uD669"),
            React.createElement("div", { className: "box__etc" })),
        React.createElement("div", { className: "box__body" },
            React.createElement("ul", { className: "datalist" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" },
                        React.createElement("img", { src: require("/static/img/icon_treesub2@3x.png"), style: { "width": "9px", "height": "14px" }, className: "mr-8 ml-6", alt: "" }),
                        "\uC0C1\uC138\uC0AC\uC5C5\uC7A5"),
                    React.createElement("p", null,
                        React.createElement("strong", null, opStatus.subZoneCount),
                        " \uAC1C")),
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" },
                        React.createElement("img", { src: require("/static/img/icon_treesub3@3x.png"), style: { "width": "9px", "height": "14px" }, className: "mr-8 ml-6", alt: "" }),
                        "\uC804\uAE30\uC2E4"),
                    React.createElement("p", null,
                        React.createElement("strong", null, opStatus.roomCount),
                        " \uAC1C")),
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" },
                        React.createElement("img", { src: require("/static/img/icon_admin.png"), style: { "width": "20px", "height": "20px" }, className: "mr-4", alt: "" }),
                        "User"),
                    React.createElement("p", null,
                        React.createElement("strong", null, opStatus.userCount),
                        " \uAC1C")),
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" },
                        React.createElement("img", { src: require("/static/img/icon_treesub4.png"), style: { "width": "10px", "height": "12px" }, className: "mr-8 ml-6", alt: "" }),
                        "\uB4F1\uB85D\uB41C \uC124\uBE44"),
                    React.createElement("p", null,
                        React.createElement("strong", null, opStatus.itemCount),
                        " ea"))),
            React.createElement("ul", { className: "datalist-small" },
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "VCB"),
                    React.createElement("p", null,
                        React.createElement("strong", null, opStatus.spg.vcbCount),
                        " ea")),
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "ACB"),
                    React.createElement("p", null,
                        React.createElement("strong", null, opStatus.spg.acbCount),
                        " ea")),
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "Mold TR"),
                    React.createElement("p", null,
                        React.createElement("strong", null, opStatus.spg.moldTrCount),
                        " ea")),
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uC720\uC785\uC2DD TR"),
                    React.createElement("p", null,
                        React.createElement("strong", null, opStatus.spg.oilTrCount),
                        " ea")),
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "GIS"),
                    React.createElement("p", null,
                        React.createElement("strong", null, opStatus.spg.gisCount),
                        " ea")),
                React.createElement("li", null,
                    React.createElement("p", { className: "tit" }, "\uBC30\uC804\uBC18"),
                    React.createElement("p", null,
                        React.createElement("strong", null, opStatus.spg.switchBoardCount),
                        " ea"))),
            React.createElement("button", { type: "button", className: "add__item", onClick: (e) => onClickGoLink(CONST.URL_ADMIN) },
                React.createElement("span", null, "\uC0AC\uC5C5\uC7A5/\uC804\uAE30\uC2E4/\uC124\uBE44 \uCD94\uAC00 \uB4F1\uB85D")))));
}
export default OperationStatus;
